import styled from 'styled-components';

export const PromptWrapper = styled.div`
  padding: 6px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

// the height should remove the tab content height
// so that we will remove the outer scroll bar
export const ContentWrapper = styled.main`
  height: calc(100% - 25px);
  width: 100%;
  display: flex;
`;

export const LeftSection = styled.div`
  padding: 8px 24px 24px 13px;
  flex: 1;
  height: 100%;
  width: 25%;
  overflow-y: scroll;

  h3 {
    font-size: 16px !important;
  }
`;

export const RightSection = styled.div`
  margin: auto;
  height: 100%;
  min-width: 725px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  align-items: center;
`;

export const RightSectionContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1400px) {
    width: 90%;
  }
`;
